export class ResponseStatusPojo {
    id: number;
    text: string;
    des: string;
    status: string;
    responseCode: number;

}